import { createContext, useContext, useState, type ReactNode } from 'react';
import { useAuth } from '../../context/AuthContext';
import { TaskDetailPanel } from '../TaskDetailPanel';

// The boards' side pane, for the task cards of the home page: the ⓘ of a card
// opens the task on the right without leaving Accueil.

type OpenTask = (taskId: number, projectId: number) => void;

const OpenTaskContext = createContext<OpenTask | null>(null);

/** Opens a task in the side pane; null outside the home page. */
export const useOpenTaskPanel = () => useContext(OpenTaskContext);

export function HomeTaskPanel({ children, onUpdated }: { children: ReactNode; onUpdated: () => void }) {
  const { user } = useAuth();
  const [open, setOpen] = useState<{ id: number; projectId: number } | null>(null);

  return (
    <OpenTaskContext.Provider value={(id, projectId) => setOpen({ id, projectId })}>
      {children}
      {open && user && (
        <TaskDetailPanel
          key={open.id}
          taskId={open.id}
          contextProjectId={open.projectId}
          currentUserId={user.id}
          onClose={() => setOpen(null)}
          onOpenDetail={() => { setOpen(null); window.location.hash = `tasks?task=${open.id}&from=${open.projectId}`; }}
          onDeleted={() => { setOpen(null); onUpdated(); }}
          onUpdated={onUpdated}
        />
      )}
    </OpenTaskContext.Provider>
  );
}
